import { render, staticRenderFns } from "./SalesInvoiceSelector.vue?vue&type=template&id=332c1a81"
import script from "./SalesInvoiceSelector.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports